import React, { useState } from "react";
import { Box, Typography, Button, Grid, Link } from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Logo from "../Asset/Images/Logo.png";
import LogoName from "../Asset/Images/LogoName.png";
import theme from "../theme";
import SubscribeModal from "./SubscribeModal";
import LocationIcon from "../Asset/Images/LocationIcon.png";

const Footer = () => {
  const [openModal, setOpenModal] = useState(false);
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "#03213A", // Deep blue background
        color: "#ffffff",
        px: { xs: 3, md: 5, lg:10 },
        py: { xs: 5, md: 8 },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Grid
        container
        justifyContent="space-between"
        alignItems="flex-start"
        sx={{ maxWidth: "1440px" }}
      >
        {/* Logo */}
        <Grid item xs={12} sm={3} md={3} lg={4}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              verticalAlign: "middle",
              gap: 1,
              background: theme.palette.background.paper,
              borderRadius: "12px",
              p: { xs: 2, md: 2, sm:2, lg:4 },
              width:{xs:'100%', sm:'fit-content'}
            }}
          >
            <Box
              component="img"
              src={Logo}
              alt="Logo"
              sx={{ height: {lg:40, md: 30, xs: 40, sm:25 } }}
            />
            <Box
              component="img"
              src={LogoName}
              alt="Logo"
              sx={{ height: {lg:40, md: 30, xs: 30, sm:25 } }}
            />
          </Box>
        </Grid>

        {/* Contact Info */}
        <Grid item xs={12} sm={4} md={4} lg={4}>
          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            sx={{
              px: { md: 10, xs: 0, sm:5 },
              alignItems: { xs: "left", md: "flex-start" },
              pt: { xs: 5, sm: 0, md: 0 },
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <LinkedInIcon fontSize="medium" />
              <Link href="https://www.linkedin.com/company/cistern-capital/" target="_blank" underline="none" color="inherit">
                <Typography variant="body2">LinkedIn</Typography>
              </Link>
            </Box>
            <Box display="flex" alignItems="center" gap={1}>
              <EmailIcon fontSize="medium" />
              <Link
                href="mailto:info@cistern.vc"
                underline="none"
                color="inherit"
              >
                <Typography variant="body2">info@cistern.vc</Typography>
              </Link>
            </Box>
            <Box display="flex" alignItems="flex-start" gap={1}>
              <Box
                component="img"
                src={LocationIcon}
                alt="Location"
                sx={{ width: 20, height: 20 }}
              />
              <Box>
                <Typography variant="body2">349 West Broadway</Typography>
                <Typography variant="body2">Unit 10</Typography>
                <Typography variant="body2">New York, NY 10013</Typography>
              </Box>
            </Box>
          </Box>
        </Grid>

        {/* Links + Subscribe */}
        <Grid
          item
          xs={12}
          sm={2}
          md={2}
          lg={2}
          display="flex"
          flexDirection="column"
          // alignItems={{ xs: "flex-start", md: "flex-end" }}
          gap={1}
          sx={{
            px: { md: 10, xs: 0 },
            alignItems: { xs: "left", md: "flex-start" },
            py: { xs: 2, sm: 0, md: 0 },
          }}
        >
          <Link href="mailto:hr@cistern.vc" underline="none" color="inherit">
            <Typography variant="body2">Careers</Typography>
          </Link>

          <Link
            href="https://cisterncapital.decilehub.com/submit_your_company"
            target="_blank"
            underline="none"
            color="inherit"
          >
            <Typography variant="body2">Pitch</Typography>
          </Link>
        </Grid>
        <Grid
          item
          xs={12}
          sm={3}
          md={2}
          lg={2}
          display="flex"
          flexDirection="column"
          alignItems={{ xs: "left", md: "flex-end", sm: "flex-start" }}
          // gap={1}
        >
          <Button
            variant="outlinedSecondary"
            size="small"
            sx={{
              mt: 1,
              width: "fit-content",
              px:3
            }}
            onClick={() => setOpenModal(true)}
          >
            Subscribe
          </Button>
        </Grid>
      </Grid>

      {/* Bottom Text */}
      <Box mt={10} textAlign="center">
        <Typography variant="body2">
          © 2023–2026 Cistern Capital LLC. All rights reserved.
        </Typography>
      </Box>
      <SubscribeModal open={openModal} onClose={() => setOpenModal(false)} />
    </Box>
  );
};

export default Footer;
